import { render, staticRenderFns } from "./SampleTypeEdit.vue?vue&type=template&id=459d19a4"
import script from "./SampleTypeEdit.vue?vue&type=script&lang=js"
export * from "./SampleTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports